export default "__VITE_ASSET__D3Ek1ogt__"